import { render, staticRenderFns } from "./nav_bottom_pc.vue?vue&type=template&id=6b524fd9"
import script from "./nav_bottom_pc.vue?vue&type=script&lang=js"
export * from "./nav_bottom_pc.vue?vue&type=script&lang=js"
import style0 from "./nav_bottom_pc.vue?vue&type=style&index=0&id=6b524fd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports